<template lang="pug">
UiModal(
  :show="show"
  @close="close"
  :title="addNew ? $t('companies.approvers.add_title') : $t('companies.approvers.edit_title')"
  :subtitle="addNew ? $t('companies.approvers.add_description') : $t('companies.approvers.edit_description')"
  :rightActions="rightActions"
)
  UiFormGroup(
    :label="$t('companies.users.name')"
    :vuelidateModel="v$.form.approver_name"
  )
    UiInput(
      v-model="form.approver_name"
      :error="v$.form.approver_name.$error"
    )

  UiFormGroup(
    :label="$t('companies.users.email')"
    :vuelidateModel="v$.form.email"
  )
    UiInput(
      v-model="form.email"
      type="email"
      :error="v$.form.email.$error"
    )

  UiFormGroup(
    v-if="form.is_approver"
    :label="$t('companies.approvers.price_limit')"
  )
    UiInput(v-model="form.price_limit")

  UiFormGroup
    UiCheckbox(
      v-model="form.is_approver"
      switch
    ) {{ $t("companies.approvers.is_approver") }}

  UiFormGroup
    UiCheckbox(
      v-model="form.is_verificator"
      switch
    ) {{ $t("companies.approvers.is_verificator") }}
</template>

<script>
import ApiApprovers from "@/api/approvers.js";
import useVuelidate from "@vuelidate/core";
import { email, required } from "@vuelidate/validators";

export default {
  setup() {
    return {
      v$: useVuelidate(),
    };
  },

  validations() {
    return {
      form: {
        approver_name: {
          required,
        },
        email: {
          required,
          email,
        },
      },
    };
  },

  data() {
    return {
      show: false,
      addNew: false,
      companyId: null,
      form: {},
    };
  },

  computed: {
    rightActions() {
      return [
        {
          label: this.$t("actions.save"),
          icon: "Check",
          onClick: this.save,
        },
      ];
    },
  },

  methods: {
    open(companyId, Approver) {
      this.v$.$reset();
      if (Approver) {
        this.addNew = false;
        this.form = {
          id: Approver.id,
          approver_name: Approver.approver_name,
          email: Approver.email,
          price_limit: Approver.price_limit,
          is_approver: Approver.is_approver,
          is_verificator: Approver.is_verificator,
        };
      } else {
        this.addNew = true;
        this.form = {
          name: "",
          email: "",
          price_limit: "",
          is_approver: false,
          is_verificator: false,
        };
      }
      this.companyId = companyId;
      this.show = true;
    },

    close() {
      this.show = false;
    },

    save() {
      this.v$.$validate().then((res) => {
        if (!res) return;
        const form = this.form;
        const params = {
          approver_name: form.approver_name,
          email: form.email,
          price_limit: form.price_limit,
          is_approver: form.is_approver,
          is_verificator: form.is_verificator,
        };
        const companyId = this.companyId;
        if (this.addNew) {
          ApiApprovers.createApprover(companyId, params)
            .then((res) => {
              this.$emit("done");
              this.close();
            })
            .catch((e) => {});
        } else {
          ApiApprovers.updateApprover(companyId, form.id, params)
            .then((res) => {
              this.$emit("done");
              this.close();
            })
            .catch((e) => {});
        }
      });
    },
  },
};
</script>
